import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Render } from '@/components/render-if'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

import { SecaoDetalhesEmpreendimento } from './secao'

type TSecaoSobreProps = {
  resumo: string | null
  quartos: string | null
  metragem: string | null
  entregas: string[] | null
}

export const SecaoSobre = ({ resumo, quartos, metragem, entregas }: TSecaoSobreProps) => {
  const { t } = useTranslation('empreendimentos')
  const dataEntregaMenor = entregas?.[0]?.slice(0, 10)

  return (
    <SecaoDetalhesEmpreendimento titulo={t('pages.detalhes.secoes.sobre.titulo')}>
      <div className="flex justify-between border-t-1 border-b-1 px-2 py-1.5 font-medium">
        <span className="flex gap-2">
          <Icon name="move-diagonal" />
          {metragem ?? '-'}
        </span>
        <span className="flex gap-2">
          <Icon name="bed-double" />
          {quartos ?? '-'}
        </span>
        <span className="flex gap-2">
          <Icon name="key-round" />
          <p>
            {t('pages.detalhes.secoes.sobre.entrega')} {entregas?.length ? dataEntregaMenor : '-'}
          </p>
          <Render.If condition={Number(entregas?.length) > 1}>
            {() => {
              return (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Icon name="circle-alert" />
                  </TooltipTrigger>
                  <TooltipContent className="px-3 py-2 text-sm font-normal" side="bottom" sideOffset={-5}>
                    {t('pages.detalhes.secoes.sobre.tooltip_datas_entrega')}
                    <ul>
                      {entregas?.map((entrega) => (
                        <li key={entrega} className="text-sm">
                          {entrega}
                        </li>
                      ))}
                    </ul>
                  </TooltipContent>
                </Tooltip>
              )
            }}
          </Render.If>
        </span>
      </div>
      <p>{resumo ?? t('pages.detalhes.secoes.sobre.sem_informacoes')}</p>
    </SecaoDetalhesEmpreendimento>
  )
}
